export interface CompratinoSignUp {
  person_document_number: string
  phone_number: string
  email: string
}

export enum PurchaseIntentionErrorCodes {
  NOT_ENOUGH_LIMIT = 1,
  MERCHANT_NOT_FOUND = 2,
  MERCHANT_NOT_APPROVED = 3,
  MERCHANT_BLOCKED = 4,
  MERCHANT_BLOCKED_KYC = 5,
  MERCHANT_WAITING_LIMIT = 6,
  MINIMUM_AMOUNT = 7,
  MERCHANT_BLOCKED_BGC = 8,
}
